export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
};

export const PACK_COLUMNS = [
  { id: 'purchaser', label: 'Purchaser', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'series_name', label: 'Series', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'product_name', label: 'Product', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'kind', label: 'Kind', defaultVisible: true, sortable: false },
  { id: 'size', label: 'Pack Size', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'redeemed', label: 'Redeemed', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'remaining', label: 'Remaining', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'expires_at', label: 'Expires', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'created_at', label: 'Purchased', defaultVisible: false, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () => PACK_COLUMNS.filter(c => c.defaultVisible);
export const getDefaultHiddenColumns = () => PACK_COLUMNS.filter(c => !c.defaultVisible);
